export function getKualaLumpurYear() {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Kuala_Lumpur",
    year: "numeric",
  });
  return Number(formatter.format(new Date()));
}

export function buildYearOptions(startYear = 2025, currentYear = getKualaLumpurYear()) {
  const years = [];
  for (let year = currentYear; year >= startYear; year -= 1) {
    years.push(year);
  }
  return years;
}

export function formatCurrency(value) {
  return Number(value ?? 0).toLocaleString("en-MY", {
    style: "currency",
    currency: "MYR",
  });
}

export function formatPercent(value) {
  return `${Number(value ?? 0).toFixed(1)}%`;
}

export function formatCategoryName(name = "") {
  if (name === "TAX") return "";
  if (name === "TRX_FEE") return "Transaction Fee";
  if (name === "KHIDMAT_KHALAQ") return "Khidmat Khalq";
  return name
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function isUserVisibleCategory(category = "") {
  return String(category).toUpperCase() !== "TAX";
}

export function categoryColor(category = "", index = 0) {
  const fixed = {
    KHUDDAM_MEMBERSHIP: "#047857",
    KHUDDAM_IJTIMA: "#65a30d",
    ATHFAL_MEMBERSHIP: "#0f766e",
    ATHFAL_IJTIMA: "#84cc16",
    LOCAL_FUND: "#2563eb",
    HALL: "#9333ea",
    KHIDMAT_KHALAQ: "#0891b2",
    TRX_FEE: "#f59e0b",
  };
  const palette = ["#dc2626", "#7c3aed", "#ea580c", "#0284c7", "#16a34a"];
  return fixed[category] || palette[index % palette.length];
}

export function formatPaymentMonth(paymentMonth = "") {
  const [year, month] = paymentMonth.split("-");
  const date = new Date(Number(year), Number(month) - 1, 1);
  if (Number.isNaN(date.getTime())) return paymentMonth || "-";
  return date.toLocaleString("en-US", { month: "short", year: "numeric" });
}

export function formatPaidAt(value) {
  if (!value) return "N/A";
  return new Date(value).toLocaleString("en-MY", {
    dateStyle: "medium",
    timeStyle: "short",
    timeZone: "Asia/Kuala_Lumpur",
  });
}

export function regularityTone(status = "") {
  return (
    {
      FULLY_PAID: {
        bg: "bg-emerald-100",
        text: "text-emerald-800",
        border: "border-emerald-200",
        label: "Fully Paid",
      },
      PARTIALLY_PAID: {
        bg: "bg-amber-100",
        text: "text-amber-800",
        border: "border-amber-200",
        label: "Partially Paid",
      },
      MISSED: {
        bg: "bg-rose-100",
        text: "text-rose-800",
        border: "border-rose-200",
        label: "Missed",
      },
      PENDING: {
        bg: "bg-amber-50",
        text: "text-amber-800",
        border: "border-amber-200",
        label: "Pending",
      },
      FUTURE: {
        bg: "bg-zinc-100",
        text: "text-zinc-500",
        border: "border-zinc-200",
        label: "Future",
      },
    }[status] || {
      bg: "bg-zinc-100",
      text: "text-zinc-700",
      border: "border-zinc-200",
      label: status || "-",
    }
  );
}

export function overallStatusLabel(status = "") {
  return (
    {
      ON_TRACK: "On Track",
      PENDING_CURRENT_MONTH: "Pending Current Month",
      NEEDS_ATTENTION: "Needs Attention",
      BEHIND: "Behind",
      NO_PAYMENT: "No Mandatory Chanda Yet",
      FULLY_PAID: "Fully Paid",
      PARTIALLY_PAID: "Partially Paid",
      MISSED: "Missed",
      PENDING: "Pending",
    }[status] || status
  );
}
